import { render, staticRenderFns } from "./yins_config.vue?vue&type=template&id=05623e56&scoped=true&"
import script from "./yins_config.vue?vue&type=script&lang=js&"
export * from "./yins_config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05623e56",
  null
  
)

export default component.exports